import React from "react";
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter";
import ContactUS from "../IndexSections/ContactUS";

function ContactUsPage() {
  return (
    <div className="contact-us-page">
      <DemoNavbar />
      <ContactUS />
      <CardsFooter />
    </div>
  );
}

export default ContactUsPage;
